/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import get from 'lodash/get';
import { withNamespaces } from 'react-i18next';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { Row, Column } from '../../../../styles/Grid';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import LinkWrapper from '../../../ui/LinkWrapper';

import {
  itemsContainerCss,
  btnsec,
  talktousCss,
  titleCss,
  descriptionCss,
  phoneNumberCss,
} from './index.styles';
import { NAVBAR_IDS } from '../../../../utils/constants';

export const onClickNavigationItem = (event, waysToWorkItems) => {
  const { id } = event.target;
  const [itemFiltered] = waysToWorkItems.filter(
    item => id === get(item, 'fields.id', 0),
  );
  const url = get(itemFiltered, 'fields.FindOutMoreCta.value.href', '');
  window.open(url, '_self');
};

class NewMyAccount extends SafePureComponent {
  state = {
    showLocationsPopup: false,
    hoveredElement: get(
      this.props.fields,
      'NavigationItems.value[0].fields.id',
      0,
    ),
  };

  onInteractionItem = event => {
    const { id } = event.target;
    this.setState({ hoveredElement: id });
  };

  showLocationPopupHandler = () => {
    this.setState({
      showLocationsPopup: true,
    });
  };
  hideLocationPopupHandler = () => {
    this.setState({
      showLocationsPopup: false,
    });
  };

  getMenuItem = (
    icon,
    linkUrl,
    anchorName,
    type,
    label,
    iconPosition,
    isActive = false,
  ) => {
    let activeClass = isActive ? 'is-active' : '';
    if (type == 'Standard') {
      return (
        <a href={linkUrl} className={activeClass}>
          {iconPosition == 'Left' ||
            (iconPosition == null && (
              <span>
                <img src={icon} alt={anchorName} />
              </span>
            ))}
          <span>{anchorName}</span>

          {iconPosition == 'Right' && (
            <span>
              <img src={icon} alt={anchorName} />
            </span>
          )}
        </a>
      );
    } else {
      return (
        <a href={linkUrl} className="sales-number">
          <span>{label}</span>
          <span>{anchorName}</span>
        </a>
      );
    }
  };
  safeRender() {
    const { fields } = this.props;
    const rightMenu = get(fields, 'NavObject.value.RightMenu', {});

    const MyAccountSectionTitle = get(rightMenu, 'MyAccountSection.Title', '');
    const MyAccountSectionIntro = get(rightMenu, 'MyAccountSection.Intro', '');
    const LoginCTAText = get(rightMenu, 'MyAccountSection.LoginCTAText', '');
    const LoginLink = get(rightMenu, 'MyAccountSection.LoginLink', '');

    const BottomSectionHeading = get(rightMenu, 'BottomSection.Heading', '');
    const BottomSectionPhoneNumber = get(
      rightMenu,
      'BottomSection.PhoneNumber',
      '',
    );
    const BottomSectionCallUsText = get(
      rightMenu,
      'BottomSection.CallUsText',
      '',
    );
    const RegisterCTAText = get(
      rightMenu,
      'MyAccountSection.RegisterCTAText',
      '',
    );
    const RegisterLink = get(rightMenu, 'MyAccountSection.RegisterLink', '');
    const IS_LOGIN = false;

    return (
      <div css={itemsContainerCss}>
        <h2>{MyAccountSectionTitle}</h2>
        {!IS_LOGIN ? <p>{MyAccountSectionIntro}</p> : <span></span>}

        {IS_LOGIN ? (
          <div>
            <ul>
              {rightMenu.MyAccountSection.Links.map((item, index) => {
                return (
                  <li key={index}>
                    {this.getMenuItem(
                      item.Icon,
                      item.Link,
                      item.LinkText,
                      item.Type,
                      item.Label,
                      item.IconPosition,
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          <div css={[btnsec]}>
            <button
              className="redbutton"
              onClick={() => (window.location = LoginLink)}
            >
              <span>
                <i className="icon-profile" />
              </span>
              <span>{LoginCTAText}</span>
            </button>

            <button
              className="greybutton"
              onClick={() => (window.location = RegisterLink)}
            >
              <span>
                <i className="icon-profile" />
              </span>
              <span>{RegisterCTAText}</span>
            </button>
          </div>
        )}
        <div css={[talktousCss]}>
          <h3>{BottomSectionHeading}</h3>

          <div css={phoneNumberCss}>
            <a href={`tel:${BottomSectionPhoneNumber}`}>
              <span className="cust-call-no">
                <i className="icon icon-contact" />
              </span>
              <span className="cust-call-us">{BottomSectionCallUsText}</span>
              <span>{BottomSectionPhoneNumber}</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

NewMyAccount.displayName = 'NavigationV2/NewMyAccount';

NewMyAccount.defaultProps = {
  t: key => key,
};

export default withNamespaces()(NewMyAccount);
